import { RootState } from 'store';
import {
  CompanyPolicyLoadError,
  CompanyPolicyLocation,
  CompanyUnitState,
} from 'types/company/time-registration/ICompanyTimeRegistrationPolicy';
import { ICostCentresCoordinatesStatusResponse } from 'types/time-registration';

export const companyPolicyAgencyNameSelector = (state: RootState): string =>
  state.companyTimeRegistrationPolicy.agencyName;
export const companyPolicyUnitsSelector = (state: RootState): CompanyUnitState[] =>
  state.companyTimeRegistrationPolicy.units;
export const companyPolicyLocationsSelector = (state: RootState): CompanyPolicyLocation[] =>
  state.companyTimeRegistrationPolicy.locations;
export const companyPolicyLoadingSelector = (state: RootState): boolean => state.companyTimeRegistrationPolicy.loading;
export const companyPolicyLoadErrorSelector = (state: RootState): CompanyPolicyLoadError =>
  state.companyTimeRegistrationPolicy.loadError;
export const companyPolicyCoordinatesStatusSelector = (
  state: RootState,
): ICostCentresCoordinatesStatusResponse | null => state.companyTimeRegistrationPolicy.coordinatesStatus;
